import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Redirect.module.css';
import { GENERAL } from 'config';

function Redirect({ user }) {
    const navigate = useNavigate();

    useEffect(() => {
        user && navigate('/');
        !user && window.location.replace(GENERAL.ADDRESSES.SSO);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return <p className={styles['redirect-text']}>Redirecting to Birdseye SSO...</p>;
}

export default Redirect;
